(function() {
  'use strict';
  angular.module('common')
  .directive('taxId', ['$http', '$q', 'taxIdFilter', function($http, $q, taxIdFilter) {
    var regex = /[^0-9]/g;
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        dsoId: '@',
        validateUnique:'@',
        showDuplicateError: '@',
        validTaxIds: '=',
        dsoErrorMsg: '=?',
        dsoExists: '='
      },
      link: function($scope, element, attrs, ngModelController) {
        element.attr('maxlength', '10');
        ngModelController.$parsers.push(function(val) {
          if (!val) {
            return '';
          }
          val = val.replace(regex,'');
          if (!val) {
            ngModelController.$setViewValue('');
            ngModelController.$render();
            return '';
          }
          if (val.length > 9) {
            val = val.substring(0,9);
          }
          if (val.length < 9){
            $scope.dsoErrorMsg = '';
          }
          var viewValue = val.substring(0,2);
          if (val.length > 2) {
            viewValue = val.substring(0,2) + '-' + val.substring(2,9);
          }
          ngModelController.$setViewValue(viewValue);
          ngModelController.$render();
          return val;
        });
        ngModelController.$formatters.push(function(val) {
          return taxIdFilter(val);
        });
        ngModelController.$validators.taxIdFormat = function(val) {
          if (!val) {
            return true;
          }
          return val.length == 9;
        };
        if ($scope.showDuplicateError == 'true') {
          ngModelController.$validators.duplicateDsoTaxId = function (val) {
            return true;
          };
          ngModelController.$validators.duplicateProviderTaxId = function (val) {
            return true;
          };
        }
        $scope.$watch(function() {
          return attrs.skipTaxIdCheck !== 'true';
        }, function(checkTaxIds) {
          if (checkTaxIds) {
            ngModelController.$asyncValidators.taxId = taxIdValidator;
          } else {
            delete ngModelController.$asyncValidators.taxId;
          }
        });
        function taxIdValidator(modelValue, viewValue) {
          if (!(ngModelController.$dirty) || !modelValue){
            return $q.resolve(true);
          }
          if ($scope.validTaxIds) {
            if(modelValue.length >= 9 ){
              return (!!_.find($scope.validTaxIds,function(validTaxId){
                  return validTaxId == modelValue;
              })) ? $q.resolve(true) : $q.reject();
            }
          }
          if($scope.validateUnique) {
            return $http.get('/providerValidate/'+ modelValue + "?dsoId=" + $scope.dsoId)
              .then(function(response) {
            	$scope.dsoErrorMsg = "";
                if (response.data) {
                  if (response.data.validation && (response.data.validation.dso == true || response.data.validation.provider == true)) {
                    if ($scope.showDuplicateError == 'true') {
                      if(response.data.validation.provider == true) {
                        ngModelController.$setValidity("duplicateProviderTaxId", !response.data.validation.provider);
                        $scope.dsoExists = true;
                        $scope.dsoErrorMsg = "This Tax ID is in use by a Provider \n";
                      }
                      if(response.data.validation.dso == true) {
                    	ngModelController.$setValidity("duplicateDsoTaxId", !response.data.validation.dso );
                        $scope.dsoExists = true;
                        if(response.data.validation.dsoName){
                          if(response.data.validation.dsoPhone)	{
                            $scope.dsoErrorMsg = $scope.dsoErrorMsg + "This Tax ID is associated with " + response.data.validation.dsoName + ", please contact " +response.data.validation.dsoPhone + " to request access.";
                          } else {
                        	   $scope.dsoErrorMsg = $scope.dsoErrorMsg + "This Tax ID is associated with " + response.data.validation.dsoName + ", please contact " +response.data.validation.dsoEmail + " to request access.";
                          }
                        }else{
                          $scope.dsoErrorMsg = $scope.dsoErrorMsg + "This Tax ID is currently under review. Please reach out to your Account Manager at 855-260-3453.";
                        }
                      }
                      return $q.resolve(true);
                    } else {
                      return $q.reject();
                    }
                  } else {
                    return $q.resolve(true);
                  }
                } else {
                  return $q.reject();
                }
            });
          } else {
            return $http.get('/provider/'+ modelValue)
              .then(function(response) {
                if(response.data) {
                  return $q.resolve(true);
                } else {
                  return $q.reject();
                }
            });
          }
        }
      }
    };
  }]).filter('taxId', [function() {
    return function(val) {
      if (val && val.length == 9) {
        return val.substring(0,2) + '-' + val.substring(2,9);
      }
      return val;
    };
  }]).directive('taxIds',['$window', function($window) {
    return {
      restrict: 'E',
      require: '^form',
      scope: {
        model: '=',
        readOnly: '@',
        inUserView: '@',
        showStatus: '@',
        autoFocus: '@',
        taxIdStatuses: '=',
        validateUnique : '@',
        dsoId: '@',
        showDuplicateError: '@'
      },
      templateUrl: '/js/common/taxId.html' + appVersion,
      link: function(scope, element, attrs, form) {
        var originalSize = 1;
        var watch = scope.$watch(()=> {
          return scope.model && scope.model.length;
        }, (newSize, oldSize) => {
          if (newSize) {
            scope.model = angular.isArray(scope.model) ? scope.model : [scope.model];
          }
          if (newSize > 1) {
            originalSize = newSize;
            watch();
          }
        });
        scope.addElement = function(val) {
          scope.model.push(val);
        };
        scope.removeElement = function(index) {
          scope.model.splice(index,1);
          if (scope.model.length !== originalSize && scope.inUserView !== "true") {
            form.$setDirty();
          }
          $window.document.getElementById('taxId' + (index ===0 ? index : index-1)).focus();
        };
      }
    };
}]);

})();
